export default __webpack_public_path__ + "static/media/img3.9f1bc32a.png";